export function Cta() {
  return (
    <svg
      width="9"
      height="15"
      viewBox="0 0 9 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2.18078 6.48562C1.45777 5.92354 0.991682 5.04586 0.991682 4.06125C0.991682 2.36865 2.36868 0.991653 4.06125 0.991653C5.75381 0.991653 7.13078 2.36865 7.13078 4.06125C7.13078 4.74929 6.90323 5.38519 6.51942 5.89763C6.5268 5.9036 6.53442 5.90925 6.54171 5.91533C6.57608 5.91345 6.61056 5.91249 6.64518 5.91249C6.96279 5.91249 7.27273 5.99403 7.54711 6.14583C7.91232 5.53643 8.12246 4.82342 8.12246 4.06125C8.12246 1.81827 6.30417 0 4.06122 0C1.81827 0 0 1.81827 0 4.06125C0 5.59244 0.847517 6.9255 2.0989 7.61749C2.12611 7.61437 2.15337 7.61158 2.18078 7.60974V6.48562Z"
        fill="black"
      />
      <path
        d="M2.18078 6.48562C1.45777 5.92354 0.991682 5.04586 0.991682 4.06125C0.991682 2.36865 2.36868 0.991653 4.06125 0.991653C5.75381 0.991653 7.13078 2.36865 7.13078 4.06125C7.13078 4.74929 6.90323 5.38519 6.51942 5.89763C6.5268 5.9036 6.53442 5.90925 6.54171 5.91533C6.57608 5.91345 6.61056 5.91249 6.64518 5.91249C6.96279 5.91249 7.27273 5.99403 7.54711 6.14583C7.91232 5.53643 8.12246 4.82342 8.12246 4.06125C8.12246 1.81827 6.30417 0 4.06122 0C1.81827 0 0 1.81827 0 4.06125C0 5.59244 0.847517 6.9255 2.0989 7.61749C2.12611 7.61437 2.15337 7.61158 2.18078 7.60974V6.48562Z"
        fill="url(#paint0_linear_8_95)"
      />
      <path
        d="M4.04625 2.60688C5.07485 2.60688 5.91169 3.44375 5.91169 4.47235V5.30715C6.15216 4.95111 6.29272 4.52231 6.29272 4.06131C6.29272 2.83083 5.29167 1.82977 4.06122 1.82977C2.83077 1.82977 1.82971 2.83083 1.82971 4.06131C1.82971 4.50249 1.95894 4.91382 2.18075 5.26043V4.47235C2.18078 3.44372 3.01762 2.60688 4.04625 2.60688Z"
        fill="black"
      />
      <path
        d="M4.04625 2.60688C5.07485 2.60688 5.91169 3.44375 5.91169 4.47235V5.30715C6.15216 4.95111 6.29272 4.52231 6.29272 4.06131C6.29272 2.83083 5.29167 1.82977 4.06122 1.82977C2.83077 1.82977 1.82971 2.83083 1.82971 4.06131C1.82971 4.50249 1.95894 4.91382 2.18075 5.26043V4.47235C2.18078 3.44372 3.01762 2.60688 4.04625 2.60688Z"
        fill="url(#paint1_linear_8_95)"
      />
      <path
        d="M7.94462 7.58894C7.85638 7.58894 7.77069 7.59999 7.6887 7.6205C7.61241 7.113 7.17356 6.72263 6.64516 6.72263C6.50514 6.72263 6.37154 6.75026 6.24916 6.79999C6.0641 6.49428 5.72837 6.28948 5.34569 6.28948C5.26165 6.28948 5.17997 6.29965 5.10158 6.31831V4.47232C5.10158 3.89041 4.62817 3.41699 4.04626 3.41699C3.46432 3.41699 2.9909 3.89041 2.9909 4.47232V8.72056L2.95171 8.68242C2.77789 8.51326 2.54861 8.41866 2.30612 8.4161C2.30277 8.41604 2.2995 8.41604 2.29618 8.41604C1.99638 8.41604 1.71285 8.56012 1.53619 8.80281C1.35755 9.04817 1.30842 9.36649 1.4047 9.65427L1.77414 10.7585C1.97303 11.353 2.29118 11.8864 2.71978 12.3439L3.55401 13.2345V14.5414H7.87816V13.2754L9.00001 11.2938V8.64427C8.99998 8.06236 8.52656 7.58894 7.94462 7.58894Z"
        fill="black"
      />
      <path
        d="M7.94462 7.58894C7.85638 7.58894 7.77069 7.59999 7.6887 7.6205C7.61241 7.113 7.17356 6.72263 6.64516 6.72263C6.50514 6.72263 6.37154 6.75026 6.24916 6.79999C6.0641 6.49428 5.72837 6.28948 5.34569 6.28948C5.26165 6.28948 5.17997 6.29965 5.10158 6.31831V4.47232C5.10158 3.89041 4.62817 3.41699 4.04626 3.41699C3.46432 3.41699 2.9909 3.89041 2.9909 4.47232V8.72056L2.95171 8.68242C2.77789 8.51326 2.54861 8.41866 2.30612 8.4161C2.30277 8.41604 2.2995 8.41604 2.29618 8.41604C1.99638 8.41604 1.71285 8.56012 1.53619 8.80281C1.35755 9.04817 1.30842 9.36649 1.4047 9.65427L1.77414 10.7585C1.97303 11.353 2.29118 11.8864 2.71978 12.3439L3.55401 13.2345V14.5414H7.87816V13.2754L9.00001 11.2938V8.64427C8.99998 8.06236 8.52656 7.58894 7.94462 7.58894Z"
        fill="url(#paint2_linear_8_95)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_8_95"
          x1="4.06123"
          y1="0"
          x2="4.06123"
          y2="7.61749"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#EC6181" />
          <stop offset="1" stopColor="#5C69E3" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_8_95"
          x1="4.06122"
          y1="1.82977"
          x2="4.06122"
          y2="5.30715"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#EC6181" />
          <stop offset="1" stopColor="#5C69E3" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_8_95"
          x1="5.17815"
          y1="3.41699"
          x2="5.17815"
          y2="14.5414"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#EC6181" />
          <stop offset="1" stopColor="#5C69E3" />
        </linearGradient>
      </defs>
    </svg>
  );
}
